// CUSTOM JS



// ------------- //
// FAQ SCHEMA for Landing Pages (structured FAQ sections)
// ------------- //

function processLandingPageFAQ(root = document) {
  // ── 1. Find the FAQ list container ──────────────────────────────────────
  const faqList = root.querySelector('[class^="faq-list-"]');
  if (!faqList) return;

  // ── 2. Prevent duplicate schema injection ────────────────────────────────
  if (document.querySelector('#faq-schema-jsonld')) return;

  // ── 3. Extract Q&A pairs ─────────────────────────────────────────────────
  const faqItems = faqList.querySelectorAll('[class^="faq-item-"]');
  if (!faqItems.length) return;

  const faqData = [];

  faqItems.forEach(item => {
    const questionEl = item.querySelector('[class^="faq-question-"]');
    const answerEl   = item.querySelector('[class^="faq-answer-"]');
    if (!questionEl || !answerEl) return;

    // Remove the toggle icon text from the question
    const toggleIcon = questionEl.querySelector('[class^="faq-toggle-icon-"]');
    const questionText = (toggleIcon
      ? questionEl.textContent.replace(toggleIcon.textContent, '')
      : questionEl.textContent
    ).trim();

    const answerText = answerEl.textContent.trim();

    if (questionText && answerText) {
      faqData.push({
        "@type": "Question",
        "name": questionText,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": answerText
        }
      });
    }
  });

  // ── 4. Inject JSON-LD schema ─────────────────────────────────────────────
  if (faqData.length === 0) return;

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = 'faq-schema-jsonld';
  script.textContent = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData
  });
  document.head.appendChild(script);
}

// ── Run ───────────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => processLandingPageFAQ(document));
document.addEventListener('shopify:section:load',   e => processLandingPageFAQ(e.target));
document.addEventListener('shopify:section:select', e => processLandingPageFAQ(e.target));


// ------------- //
// FAQ SCHEMA on Product Page
// ------------- //

function processFAQ(root = document) {

  const rte = root.querySelector('.rte.product-description');
  if (!rte) return;

  // ── 1. Find FAQ heading in any h1–h5 that starts with "FAQ" ──────────────
  const faqHeading = Array.from(rte.querySelectorAll("h1,h2,h3,h4,h5"))
    .find(h => /^faq/i.test(h.textContent.trim()));

  if (!faqHeading) return;

  // ── 2. Collect top-level sibling elements after the FAQ heading ───────────
  // Hard-stop on a heading only after we've confirmed ≥1 complete pair
  const topEls = [];
  let el = faqHeading.nextElementSibling;

  while (el) {
    if (/^H[1-5]$/.test(el.tagName)) break; // stop at any heading for now, refine later
    topEls.push(el);
    el = el.nextElementSibling;
  }

// Remove empty spacer elements (e.g. <p><br></p>) directly after the FAQ heading
while (
  topEls.length &&
  !topEls[0].textContent.trim() &&
  !topEls[0].querySelector('img')
) {
  topEls.shift().remove();
}

if (topEls.length === 0) return;

  // ── 3. Normalize into virtual lines ──────────────────────────────────────
  // Each line = { text: string, html: string, sourceEl: topLevelElement }
  // We recurse into each top-level element, splitting on block/br boundaries.
  // sourceEl always points to the TOP-LEVEL sibling (the one we'll remove).

  const BLOCK_TAGS = new Set([
    "P","DIV","DT","DD","LI","TR","BLOCKQUOTE","H1","H2","H3","H4","H5","H6"
  ]);

  function normalizeToLines(topEl) {
    const lines = [];
    let currentTextParts = [];
    let currentHtmlParts = [];

    function flush() {
      const text = currentTextParts.join("").trim();
      const html = currentHtmlParts.join("").trim();
      if (text) {
        lines.push({ text, html, sourceEl: topEl });
      }
      currentTextParts = [];
      currentHtmlParts = [];
    }

    function walk(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        currentTextParts.push(node.textContent);
        currentHtmlParts.push(node.textContent
          .replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;"));
        return;
      }
      if (node.nodeType !== Node.ELEMENT_NODE) return;

      const tag = node.tagName.toUpperCase();

      if (tag === "BR") {
        flush();
        return;
      }

      if (BLOCK_TAGS.has(tag)) {
        flush();
        // For inline-rich block elements, preserve inner HTML
        const innerHtml = node.innerHTML.trim();
        const innerText = node.textContent.trim();
        if (innerText) {
          lines.push({ text: innerText, html: innerHtml, sourceEl: topEl });
        }
        return; // don't recurse further — innerHtml already captured
      }

      // Inline elements (strong, a, em, span, etc.) — walk children
      // but capture their outer HTML to preserve formatting
      currentTextParts.push(node.textContent);
      currentHtmlParts.push(node.outerHTML);
    }

    // Walk direct children of the top element
    for (const child of topEl.childNodes) {
      walk(child);
    }
    flush();

    return lines;
  }

  // Build full line list across all top-level elements
  // Also track "visual-only" elements (like img-only paragraphs) separately
  const allLines = []; // { text, html, sourceEl }

  for (const topEl of topEls) {
    const lines = normalizeToLines(topEl);
    if (lines.length === 0) {
      // Empty or visual-only element (e.g. <p><img></p>, <p><br></p>)
      // Mark with empty text so we can handle it as a visual continuation
      allLines.push({ text: "", html: topEl.innerHTML, sourceEl: topEl, isVisual: true });
    } else {
      allLines.push(...lines);
    }
  }

  // ── 4. PASS 1 — Parse Q/A pairs from virtual lines ───────────────────────
  // Each pair tracks which sourceEls were consumed so we know what to remove.

  const pairs = [];
  let i = 0;

  while (i < allLines.length) {
    const line = allLines[i];

    // Skip empty/visual lines between pairs
    if (!line.text || line.isVisual) { i++; continue; }

    if (/^Q:/i.test(line.text)) {
      const pair = {
        questionText: line.text.replace(/^Q:\s*/i, "").trim(),
        questionHtml: line.html.replace(/^Q:\s*/i, "").trim(),
        answerText: "",
        answerHtml: "",
        sourceEls: new Set([line.sourceEl])
      };
      i++;

      // Q continuation lines (non-empty, non-A, non-Q)
      while (i < allLines.length) {
        const next = allLines[i];
        if (!next.text && !next.isVisual) { i++; continue; }
        if (next.isVisual) { i++; continue; }
        if (/^A:/i.test(next.text) || /^Q:/i.test(next.text)) break;
        pair.questionText += " " + next.text;
        pair.questionHtml += " " + next.html;
        pair.sourceEls.add(next.sourceEl);
        i++;
      }

      // Must find an A:
      if (i >= allLines.length || !/^A:/i.test(allLines[i].text)) {
        // No answer found, skip this Q
        continue;
      }

      const aLine = allLines[i];
      pair.answerText = aLine.text.replace(/^A:\s*/i, "").trim();
      pair.answerHtml = aLine.html.replace(/^A:\s*/i, "").trim();
      pair.sourceEls.add(aLine.sourceEl);
      i++;

      // A continuation lines — collect speculatively
      // We'll validate in Pass 2 whether these are real continuations
      const contLines = [];
      while (i < allLines.length) {
        const next = allLines[i];
        // Stop on next Q (real or visual+Q)
        if (next.text && /^Q:/i.test(next.text)) break;
        // Stop on non-empty, non-visual that isn't obviously a continuation
        contLines.push(next);
        i++;
      }
      pair._contLines = contLines; // store for Pass 2

      pairs.push(pair);

    } else {
      // Non-Q line before any pair or between pairs — leave in DOM
      i++;
    }
  }

  if (pairs.length === 0) return;

  // ── 5. PASS 2 — Validate continuation lines ───────────────────────────────
  // For each pair (except the last), contLines are valid if they precede a Q.
  // Since we already stopped collecting at the next Q, all contLines for
  // non-last pairs are valid by construction.
  // For the LAST pair, we drop contLines — no following Q to confirm them.

  for (let p = 0; p < pairs.length; p++) {
    const pair = pairs[p];
    const isLast = p === pairs.length - 1;
    const contLines = pair._contLines || [];

    for (const line of contLines) {
      if (isLast) {
        // Don't consume — leave in DOM (could be trailing content or spacing)
        continue;
      }
      // Valid continuation
      if (line.isVisual) {
        // Visual-only (img paragraph, empty spacer) — append raw HTML
        pair.answerHtml += " " + line.html;
        pair.sourceEls.add(line.sourceEl);
      } else if (line.text) {
        pair.answerText += " " + line.text;
        pair.answerHtml += " " + line.html;
        pair.sourceEls.add(line.sourceEl);
      }
    }

    // Also: visual-only elements immediately after A (before next Q) for ALL pairs
    // These are things like <p><img...></p> that belong to the answer visually
    // We already handled this above for non-last pairs.
    // For the last pair, still pull in visual-only els (img etc) that directly follow A
    // but stop at the first non-empty, non-visual line.
    if (isLast) {
      for (const line of contLines) {
        if (line.isVisual && line.html.includes("<img")) {
          pair.answerHtml += " " + line.html;
          pair.sourceEls.add(line.sourceEl);
        } else {
          break; // stop at first non-visual continuation
        }
      }
    }

    delete pair._contLines;
  }

  // ── 6. Build dropdowns and replace participating elements ─────────────────
  const faqData = [];

  for (const pair of pairs) {
    const details = document.createElement("details");
    details.className = "faq-dropdown";
    details.innerHTML = `
      <summary>${escapeHTML(pair.questionText)}</summary>
      <div>${pair.answerHtml}</div>
    `;

    // Insert before the first sourceEl in DOM order
    const sourceElsOrdered = [...pair.sourceEls].sort((a, b) => {
      const pos = a.compareDocumentPosition(b);
      return pos & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });

    sourceElsOrdered[0].before(details);
    for (const el of sourceElsOrdered) el.remove();

    faqData.push({
      "@type": "Question",
      "name": pair.questionText,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": pair.answerText
      }
    });
  }

  // ── 7. JSON-LD schema ─────────────────────────────────────────────────────
  if (faqData.length === 0 || document.querySelector("#faq-schema-jsonld")) return;

  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = "faq-schema-jsonld";
  script.textContent = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData
  });
  document.head.appendChild(script);
}

function escapeHTML(str) {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

// ── Run ───────────────────────────────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", () => processFAQ(document));
document.addEventListener("shopify:section:load", e => processFAQ(e.target));
document.addEventListener("shopify:section:select", e => processFAQ(e.target));



// ------- //
// FOR PRODUCT SCHEMA ENHANCEMENT
// ------- //
(function () {
 
  // ── Tiny deterministic string hash (djb2-ish, no deps) ────────────────────
  function hashStr(str) {
    let h = 0;
    for (let i = 0; i < str.length; i++) {
      h = (h * 31 + str.charCodeAt(i)) | 0;
    }
    return String(h);
  }
 
  function processProductSchema() {
 
    // ── 1. Only run on product pages ─────────────────────────────────────────
    if (!window.location.pathname.includes('/products/')) return;
 
    // ── 2. Clean up orphaned v1 standalone shipping tag if present ────────────
    const orphaned = document.querySelector('#shipping-schema-jsonld');
    if (orphaned) orphaned.remove();
 
    // ── 3. Shared shipping details object (reused across all tags) ────────────
    const shippingDetails = {
      "@type": "OfferShippingDetails",
      "shippingRate": {
        "@type": "MonetaryAmount",
        "value": "0.00",
        "currency": "USD"
      },
      "shippingDestination": {
        "@type": "DefinedRegion",
        "addressCountry": "US",
        "addressRegion": [
          "AL","AR","AZ","CA","CO","CT","DC","DE","FL","GA",
          "IA","ID","IL","IN","KS","KY","LA","MA","MD","ME",
          "MI","MN","MO","MS","MT","NC","ND","NE","NH","NJ",
          "NM","NV","NY","OH","OK","OR","PA","RI","SC","SD",
          "TN","TX","UT","VA","VT","WA","WI","WV","WY"
        ]
      },
      "deliveryTime": {
        "@type": "ShippingDeliveryTime",
        "handlingTime": {
          "@type": "QuantitativeValue",
          "minValue": 0,
          "maxValue": 1,
          "unitCode": "DAY"
        },
        "transitTime": {
          "@type": "QuantitativeValue",
          "minValue": 3,
          "maxValue": 15,
          "unitCode": "DAY"
        },
        "cutoffTime": "15:00-05:00",
        "businessDays": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "https://schema.org/Monday",
            "https://schema.org/Tuesday",
            "https://schema.org/Wednesday",
            "https://schema.org/Thursday",
            "https://schema.org/Friday"
          ]
        }
      }
    };
 
    // ── 4. Shared offer injector ──────────────────────────────────────────────
    const endOfYear = new Date(new Date().getFullYear(), 11, 31).toISOString().split('T')[0];
 
    const injectIntoOffer = (offer) => {
      if (!offer || typeof offer !== 'object') return;
      offer.shippingDetails = shippingDetails;
      offer.itemCondition = offer.itemCondition || "https://schema.org/NewCondition";
      offer.priceValidUntil = offer.priceValidUntil || endOfYear;

      if (offer.availability === "http://schema.org/OutOfStock" ||
          offer.availability === "https://schema.org/OutOfStock") {
            delete offer.availability;
          }
    };
 
    const injectIntoSchema = (schema) => {
      if (schema.offers) {
        if (Array.isArray(schema.offers)) {
          schema.offers.forEach(injectIntoOffer);
        } else {
          injectIntoOffer(schema.offers);
        }
      }
 
      if (Array.isArray(schema.hasVariant)) {
        schema.hasVariant.forEach(variant => {
          if (!variant.description && schema.description) {
            variant.description = schema.description;
          }
 
          if (!variant.offers) return;
          if (Array.isArray(variant.offers)) {
            variant.offers.forEach(injectIntoOffer);
          } else {
            injectIntoOffer(variant.offers);
          }
        });
      }
    };
 
    // ── 5. Find and patch all relevant schema tags ────────────────────────────
    // Reprocess a tag if it's a new tag OR its content changed since we last
    // stamped it, instead of skipping forever once touched.
    const allScriptTags = [...document.querySelectorAll('script[type="application/ld+json"]')];
 
    const targetTags = allScriptTags.filter(s => {
      const currentHash = hashStr(s.textContent);
      if (s.dataset.enhancedHash === currentHash) return false; // unchanged since we last processed it
      try {
        const json = JSON.parse(s.textContent);
        const type = json?.['@type'];
        return (
          (type === 'Product' && !!json.offers) ||
          (type === 'ProductGroup' && Array.isArray(json.hasVariant))
        );
      } catch { return false; }
    });
 
    if (targetTags.length === 0) return;
 
    // ── 6. Parse all target tags first (needed for cross-tag harmonization) ──
    const parsedSchemas = [];
 
    for (const tag of targetTags) {
      let schema;
      try {
        schema = JSON.parse(tag.textContent);
      } catch (e) {
        console.warn('[processProductSchema] Failed to parse schema tag', e);
        continue;
      }
      injectIntoSchema(schema);
      parsedSchemas.push({ tag, schema });
    }
 
    // ── 7. Harmonize aggregateRating/review: Product → ProductGroup ──────────
    const hasValidRating = (s) =>
      s?.aggregateRating &&
      Number(s.aggregateRating.ratingValue) > 0 &&
      Number(s.aggregateRating.reviewCount || s.aggregateRating.ratingCount) > 0;
 
    const productEntry = parsedSchemas.find(p => p.schema['@type'] === 'Product');
    const groupEntry = parsedSchemas.find(p => p.schema['@type'] === 'ProductGroup');
 
    if (groupEntry && !hasValidRating(groupEntry.schema)) {
      let source = hasValidRating(productEntry?.schema) ? productEntry.schema : null;
 
      if (!source && Array.isArray(groupEntry.schema.hasVariant)) {
        source = groupEntry.schema.hasVariant.find(hasValidRating);
      }
 
      if (source) {
        groupEntry.schema.aggregateRating = source.aggregateRating;
        if (source.review) groupEntry.schema.review = source.review;
      }
    }
 
    // ── 8. Trim field lengths to stay within Google's structured-data limits ─
    // description: house style cap, well under Google's feed limit.
    const trimDescription = (schema) => {
      if (!schema || typeof schema.description !== 'string') return;
      const plain = schema.description.replace(/<[^>]*>/g, '').trim(); // strip HTML
      if (plain.length > 1000) {
        schema.description = plain.slice(0, 1000).replace(/\s+\S*$/, '') + '...';
      } else {
        schema.description = plain;
      }
    };
 
    // name: Google Merchant Center's title attribute (maps to schema.org
    // Product.name) is a hard 1–150 character limit. Over that, Search
    // Console's Merchant listings report flags "Invalid string length in
    // field 'name'". Trim from the end with no ellipsis — the important
    // keywords belong up front, and shoppers mostly only see the first ~70
    // characters anyway, so "..." just burns characters for nothing.
    // https://support.google.com/merchants/answer/6324415
    const trimName = (schema) => {
      if (!schema || typeof schema.name !== 'string') return;
      const plain = schema.name.replace(/<[^>]*>/g, '').trim();
      if (plain.length > 150) {
        schema.name = plain.slice(0, 150).replace(/\s+\S*$/, '');
      } else {
        schema.name = plain;
      }
    };
 
    for (const { schema } of parsedSchemas) {
      trimDescription(schema);
      trimName(schema);
      if (Array.isArray(schema.hasVariant)) {
        schema.hasVariant.forEach(trimDescription);
        schema.hasVariant.forEach(trimName);
      }
    }
 
    // ── 9. Write back ──────────────────────────────────────────────────────
    for (const { tag, schema } of parsedSchemas) {
      const newContent = JSON.stringify(schema, null, 2);
      tag.textContent = newContent;
      tag.dataset.enhancedHash = hashStr(newContent); // stamp with hash of the content we just wrote
    }
  }
 
  // ── 10. Run once as soon as the DOM is ready ────────────────────────────────
  function init() {
    processProductSchema();
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
  // ── 11. Watch for late rewrites (review apps, personalization/AB tools,
  // etc.) and reprocess automatically. Debounced so a burst of unrelated DOM
  // mutations only triggers one re-run.
  let debounceTimer = null;
  const scheduleReprocess = () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(processProductSchema, 150);
  };
 
  const isJsonLdScript = (node) =>
    node && node.nodeType === Node.ELEMENT_NODE &&
    node.matches && node.matches('script[type="application/ld+json"]');
 
  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some(m => {
      // content of an existing json-ld tag changed
      const target = m.target.nodeType === Node.TEXT_NODE ? m.target.parentElement : m.target;
      if (isJsonLdScript(target)) return true;
      // a new/replacement json-ld tag was added (some apps swap the node
      // instead of mutating it in place)
      if (m.addedNodes) {
        for (const n of m.addedNodes) {
          if (isJsonLdScript(n)) return true;
        }
      }
      return false;
    });
    if (relevant) scheduleReprocess();
  });
 
  // Covers both text-content changes to existing tags and whole-tag
  // replacements, anywhere in the document. If you know json-ld tags only
  // ever live in <head>, you can scope this to document.head instead for a
  // slightly smaller observation surface.
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
 
})();

// ── Run ───────────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => processProductSchema());
document.addEventListener('shopify:section:load', () => processProductSchema());
document.addEventListener('shopify:section:select', () => processProductSchema());